import React from "react";
import "./EmailDisplay.css";

const EmailDisplay = ({ email = "careers@pinkmoontech.com" }) => {
  return (
    <span className="email-display-text">
      {email}
    </span>
  );
};

export default EmailDisplay;
